module.exports = __webpack_public_path__ + "static/media/Terminos_y_condiciones.4558ef4d.pdf";